import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'ipc-company-selector.preload-company',
    country: ['CO'],
    options: {
      Construagil_App: { companyCode: '7544' }
    }
  },
  {
    feature: 'ipc-company-selector.version-3',
    country: ['CO'],
    role_any: 'ARMORGAPC,ARMORGAPS,ARMORGARCAdv,ARMORGARU,ARMORGCash,ARMORGGOODRECEIPT,ARMORGLIEN,ARMORGreconcile,ARMORGREQUESTCREDIT,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFGOODRECEIPT,ARMSTAFFReconcile,ARMSTAFFREQUESTCREDIT,ARMSTAFFSCONF,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,CAORGARCAdv,CAORGAPC'
  }
] as IAppConfiguration[];
